import { useQuery } from '@tanstack/react-query';

import { fetcher } from '~lib/api/fetch';
import { CompanyBase } from '~types/company';

import QueryKeys from '../queryKeys';

const getUrl = (id?: string) => `/api/company/${id}/suggestion`;

interface CompanySuggestionResponse extends CompanyBase {
  salary: number;
}

export function useCompanySuggestion(id: string) {
  return useQuery<CompanySuggestionResponse[]>(
    [QueryKeys.companySuggestion, id],
    () => fetcher<CompanySuggestionResponse[]>(getUrl(id)),
    {
      enabled: !!id,
    },
  );
}
